import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';

export const MarketplaceProductConfigRoute = {
  LIST_PAGE: 'marketplaceproductconfig',
};

export const router = PageRouteConfig.factory(
  [
    {
      path: '/marketplaceproductconfig',
      name: MarketplaceProductConfigRoute.LIST_PAGE,
      component: () =>
        import(
          /* webpackChunkName: "marketplaceproductconfig" */ './pages/MarketplaceProductConfigPage.vue'
        ),
    },
  ],
  Module.CATALOGUESETTING
);
